import { formatDate } from "../../utils/formatDate";
import { buildExtractUrl } from "../../utils/utils";
import { BookExtractHeader } from "./types";


// Single source of truth for the table columns.
export const bookExtractHeaders: BookExtractHeader[] = [
  {
    key: "index",
    label: "#",
    sortable: false,
    className: "book-table__cell--index",
    render: (_book, index) => index + 1,
  },
  {
    key: "jacketUrl",
    label: "Cover",
    sortable: false,
    className: "book-table__cell--cover",
    render: (book) => (
      <a
        href={buildExtractUrl(book.isbn)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={book.jacketUrl}
          alt={`Cover of ${book.title}`}
          loading="lazy"
        />
      </a>
    ),
  },
  {
    key: "author",
    label: "Author",
    sortable: true,
    sortType: "string",
    render: (book) => book.author,
  },
  {
    key: "authorBiography",
    label: "Biography",
    sortable: false,
    className: "book-table__cell--biography",
    render: (book) => <span>{book.authorBiography}</span>,
  },
  {
    key: "title",
    label: "Title",
    sortable: true,
    sortType: "string",
    render: (book) => (
      <a
        href={buildExtractUrl(book.isbn)}
        target="_blank"
        rel="noopener noreferrer"
      >
        {book.title}
      </a>
    ),
  },
  {
    key: "estimatedReadingTimeMinutes",
    label: "Reading time (minutes)",
    sortable: true,
    sortType: "number",
    render: (book) => book.estimatedReadingTimeMinutes,
  },
  {
    key: "publicationDate",
    label: "Publication date",
    sortable: true,
    sortType: "date",
    render: (book) => formatDate(book.publicationDate),
  },
];
